import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { LuDownload, LuSmartphone } from "react-icons/lu";
import { BASEURL, config } from "../config/config";
import Header from "./Header";

function DownloadPageApk() {
  const [loading, setLoading] = useState(false);

  // Download APK
  // const downloadFileOld = async () => {
  //   try {
  //     setLoading(true);

  //     const response = await fetch(`${BASEURL}/chat/downloadApk`, config);

  //     if (!response.ok) {
  //       throw new Error("Failed to download APK");
  //     }

  //     const blob = await response.blob();

  //     // Create blob URL
  //     const fileUrl = window.URL.createObjectURL(blob);

  //     // Create download link
  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.download = "shareurinterest.apk";

  //     document.body.appendChild(link);
  //     link.click();

  //     document.body.removeChild(link);

  //     // Cleanup
  //     window.URL.revokeObjectURL(fileUrl);
  //   } catch (error) {
  //     console.error("Download Error:", error);
  //     alert("Failed to download APK");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const downloadFile = () => {
    try {
      setLoading(true);

      window.location.href = `${BASEURL}/chat/downloadApk`;
    } catch (error) {
      console.error(error);
      alert("Download failed");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, [4000]);
    }
  };

  return (
    <>
      <Header />

      <div
        style={{
          minHeight: "80vh",
          // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
        className="d-flex align-items-center justify-content-center p-3"
      >
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} sm={10} md={8} lg={5}>
              <Card
                className="border-0 shadow-lg rounded-5 overflow-hidden"
                style={{
                  backdropFilter: "blur(10px)",
                }}
              >
                {/* Top Section */}
                <div
                  className="text-center text-white p-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #872de7 0%, #7b1ce0 100%)",
                  }}
                >
                  <div
                    className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle bg-white"
                    style={{
                      width: "90px",
                      height: "90px",
                    }}
                  >
                    <LuSmartphone size={45} color="#872de7" />
                  </div>

                  <h2 className="fw-bold mb-2">Download APK</h2>

                  <p className="mb-0 opacity-75">
                    Install the latest Android app version
                  </p>
                </div>

                {/* Bottom Section */}
                <Card.Body className="p-4 p-md-5 text-center">
                  <div className="mb-4">
                    <h4 className="fw-bold text-dark">ShareUrInterest App</h4>

                    <p className="text-muted mb-0">
                      Fast, secure and easy to use application.
                    </p>
                  </div>

                  <Button
                    onClick={downloadFile}
                    disabled={loading}
                    size="lg"
                    className="w-100 border-0 rounded-4 py-3 fw-semibold fs-5 d-flex align-items-center justify-content-center gap-2"
                    style={{
                      background:
                        "linear-gradient(135deg, #872de7 0%, #872de7 100%)",
                    }}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" />
                        Downloading...
                      </>
                    ) : (
                      <>
                        <LuDownload size={24} />
                        Download APK
                      </>
                    )}
                  </Button>

                  <div className="mt-4">
                    <small className="text-muted">
                      Compatible with Android 8.0+
                    </small>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default DownloadPageApk;
